import { type PrimitiveAtom, atom } from 'jotai';
import type { ReviewSnippetsData } from './types';

export const MOCK_REVIEW_SNIPPETS_DATA: ReviewSnippetsData = {
	snippets: [
		{
			reviewerName: 'Stefani & Alexandre K.',
			excerpt:
				'Working with this vendor was an absolute dream. They were attentive, professional, and made our special day even more magical than we imagined possible.',
			rating: 5,
			reviewDate: '2025-11-14',
		},
		{
			reviewerName: 'Monica T.',
			excerpt:
				'From our first consultation to the final moments of our reception, every detail was handled with incredible care and expertise. Highly recommend to any couple.',
			rating: 5,
			reviewDate: '2025-10-03',
		},
	],
	totalReviewCount: 375,
	averageRating: 4.9,
};

export const reviewSnippetsDataAtom: PrimitiveAtom<ReviewSnippetsData | null> =
	atom<ReviewSnippetsData | null>(null);
